import React, { useEffect, useState } from "react";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import { ReactSVG } from "react-svg";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Profile from "../Profile/Profile";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { clearUser, selectIsLoggedIn } from "../../Redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { FiLogOut, FiX } from "react-icons/fi";
import { SiCircle } from "react-icons/si";
import ManageSubscription from "../../Asset/Manage Subscription.svg";
import sideBarLogo from "../../Asset/ZT-Sidebar-logo.svg";
import gradientArrow from "../../Asset/gradient arrow.svg";
import { toast } from "react-toastify";
import axios from "axios";

const pages = [
  { name: "Home", link: "/" },
  { name: "Demo", link: "/demo" },
  { name: "Pricing", link: "/pricing" },
  { name: "Help", link: "/help" },
  { name: "App", link: "/app" },
];

const Navbar = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);

  const isSettingsPage = location.pathname.startsWith("/settings");
  const isWebAppPage = location.pathname.startsWith("/app");
  const isUsagePage = location.pathname.startsWith("/usage");
  const isSignupSuccessPage = location.pathname.startsWith("/signup-successful");

  const visiblePages = isSignupSuccessPage
    ? pages.filter((p) => p.name !== "App")
    : pages;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 50) {
      setShowNavbar(false);
    } else if (currentScrollY < lastScrollY) {
      setShowNavbar(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastScrollY]);

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}api/auth/logout`,
        {},
        { withCredentials: true }
      );

      if (response?.data?.success) {
        toast.success(response.data?.message, { toastId: "logout" });
        dispatch(clearUser());
        navigate("/");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.response?.data?.message || "Logout failed", { toastId: "logout" });
    }
  };

  return (
    <div
      className={`navbar ${showNavbar ? "show" : "hide"
        } w-full transition-transform duration-300 z-50 font-inter`}
    >
      <div className="relative">
        {/* Top Bar */}
        <div className="p-3 flex items-center justify-between mx-auto md:mt-8 mt-4 w-[95%] max-w-[1450px] md:bg-[#FFFFFF4D] bg-[#FFFFFF33] shadow-md backdrop-blur-md md:rounded-full rounded-2xl">
          <ReactSVG
            src={zeroTypingLogo}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
            }}
            className="w-auto"
          />

          {/* Nav Links */}
          <div className="hidden md:flex lg:gap-5 gap-3 lg:text-[1.2rem] text-base font-medium">
            {visiblePages?.map((page, i) => (
              <NavLink
                to={page.link}
                key={i}
                className={({ isActive }) =>
                  isActive ? "text-[#3AB1F6]" : "text-[#00000080]"
                }
              >
                {page.name}
              </NavLink>
            ))}
          </div>

          {/* Right Side */}
          <div className="hidden md:flex items-center gap-2">
            <NavLink
              to="/download"
              className="bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out text-white lg:text-[1.15rem] text-base font-semibold py-[10px] flex justify-center items-center px-4 rounded-full"
            >
              Download App
            </NavLink>

            {isLoggedIn ? (
              <Profile />
            ) : (
              <NavLink
                to="/login"
                className="bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out text-white lg:text-[1.15rem] text-base font-semibold py-[10px] flex justify-center items-center px-6 rounded-full"
              >
                Login
              </NavLink>
            )}
          </div>

          {/* Mobile */}
          <div className="flex md:hidden items-center gap-2">
            <NavLink
              to={"/download"}
              className="bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out font-inter text-white text-xs w-max p-2.5 px-5 leading-none rounded-full font-semibold"
            >
              Download App
            </NavLink>
            <HiOutlineMenuAlt4 onClick={() => setIsOpen(true)} className="size-5" />
          </div>
        </div>

        {/* Mobile Drawer */}
        <div
          className={`absolute md:hidden inset-y-0 right-0 left-0 -top-5 p-4 pt-8 rounded-b-xl w-full h-max shadow-md bg-white z-50 transition-transform duration-700 ease-in-out ${isOpen ? "-translate-y-0" : "-translate-y-[105%]"
            }`}
        >
          <div className="flex items-center justify-between gap-2">
            <ReactSVG
              src={zeroTypingLogo}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "w-auto h-10");
              }}
              className="w-auto"
            />
            <FiX onClick={() => setIsOpen(false)} className="size-7" />
          </div>

          <div className="flex flex-col gap-2 mt-4 w-full font-medium font-inter">
            {visiblePages?.map((page, i) => (
              <NavLink
                key={i}
                to={page.link}
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-between gap-2 text-lg text-[#35353599] py-2"
              >
                {page.name}
                <ReactSVG
                  src={gradientArrow}
                  beforeInjection={(svg) => {
                    svg.setAttribute("class", "w-auto h-4");
                  }}
                  className="w-auto"
                />
              </NavLink>
            ))}

            <div className="flex flex-col items-start gap-4 text-sm font-medium">
              {isLoggedIn && !isWebAppPage && (
                <NavLink
                  to={"/app"}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center justify-between gap-2 w-full"
                >
                  <div className="flex items-center gap-3">
                    <ReactSVG
                      src={sideBarLogo}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-7 h-7");
                      }}
                      className="w-auto"
                    />
                    <div className="flex flex-col font-inter">
                      <span className="text-lg font-semibold text-[#353535]">
                        Web App
                      </span>
                      <span className="text-xs text-[#3535359E]">
                        Access the Zero Tying app!
                      </span>
                    </div>
                  </div>

                  <div className="pt-1">
                    <ReactSVG
                      src={gradientArrow}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-auto h-4");
                      }}
                      className="w-auto"
                    />
                  </div>
                </NavLink>
              )}

              {/* Hide this entry if already on /settings */}
              {isLoggedIn && !isSettingsPage && (
                <NavLink
                  to={"/settings"}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center justify-between gap-2 w-full"
                >
                  <div className="flex items-center gap-3">
                    <ReactSVG
                      src={ManageSubscription}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-7 h-7");
                      }}
                      className="w-auto"
                    />
                    <div className="flex flex-col font-inter">
                      <span className="text-lg font-semibold text-[#353535]">
                        Manage Subscription
                      </span>
                      <span className="text-xs text-[#3535359E]">
                        Access billing and plan settings
                      </span>
                    </div>
                  </div>

                  <div className="pt-1">
                    <ReactSVG
                      src={gradientArrow}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-auto h-4");
                      }}
                      className="w-auto"
                    />
                  </div>
                </NavLink>
              )}

              {/* Usage */}
              {isLoggedIn && !isUsagePage && (
                <NavLink
                  to={"/usage"}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center justify-between gap-2 w-full"
                >
                  <div className="flex items-center gap-3">
                    <SiCircle size={26} />
                    <div className="flex flex-col font-inter">
                      <span className="text-lg font-semibold text-[#353535]">
                        Usage
                      </span>
                      <span className="text-xs text-[#3535359E]">
                        Track your plan usage and remaining limits
                      </span>
                    </div>
                  </div>

                  <div className="pt-1">
                    <ReactSVG
                      src={gradientArrow}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-auto h-4");
                      }}
                      className="w-auto"
                    />
                  </div>
                </NavLink>
              )}

              <div className="h-[1px] bg-[#0000001A] w-full" />

              {isLoggedIn ? (
                <button
                  onClick={() => {
                    handleLogout();
                    setIsOpen(false);
                  }}
                  className="flex items-center gap-3 w-full rounded-xl text-[#353535] text-xl font-semibold font-inter"
                >
                  <FiLogOut className="size-6 text-[#353535]" />
                  Logout
                </button>
              ) : (
                <NavLink
                  to={"/login"}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center justify-between w-full gap-2 text-lg text-[#000] font-inter font-medium py-2"
                >
                  Sign In
                  <ReactSVG
                    src={gradientArrow}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "w-auto h-4");
                    }}
                    className="w-auto"
                  />
                </NavLink>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
